import { i18n } from '@lingui/core';

import messages from './messages';

type locale = keyof typeof messages;
export default async function activateLocale(locale: locale) {
  const { messages } = await import(`../locales/${locale}.po`);
  if (!messages) {
    console.error(`Unknown locale ${locale}`);
    return activateLocale('en');
  }

  i18n.load(locale, messages);
  i18n.activate(locale);
}
